import { Button } from '@/ui/button-2.tsx';

const boxClassName =
  'mx-auto mb-16 flex w-full max-w-[900px]! justify-center rounded-lg border border-transparent bg-white px-6 pt-6 pb-10 text-v1-background-200 shadow-[0px_2px_4px_rgba(0,0,0,0.02)] sm:mb-32 sm:px-10 sm:pb-14 sm:pt-10';

const innerClassName = 'flex w-full max-w-[550px] flex-col sm:min-w-[330px]';

const HeaderSection: React.FC<{ action: () => void }> = ({ action }) => {
  return (
    <div className={boxClassName}>
      <div className={innerClassName}>
        <p className="typography-v1-legacy-h2 font-extrabold!">Ta en gratis kredittsjekk</p>
        <p className="mx-0 mt-6 mb-10 typography-v1-legacy-p1">
          En god kredittscore kan gi deg lavere rente ved lånesøknad og refinansiering av gjeld.
        </p>
        <Button action={action} color="yellow" className="mx-auto!">
          Sjekk gratis nå!
        </Button>
      </div>
    </div>
  );
};

export default HeaderSection;
